<template>
  <div class="feature-container">
    <div class="feature-title top">
      <div class="h1">{{ t('home.features.title') }}</div>
      <div class="right-text">
        <h3>{{ t('home.features.subtitle') }}</h3>
        <P>{{ t('home.features.description') }}</P>
      </div>
    </div>
    <!-- 左侧功能列表 -->
    <div class="list-wrap">
      <div class="feature-list">
        <div
          v-for="(item, index) in features"
          :key="index"
          class="feature-item"
          :class="{ active: activeIndex === index }"
          @click="handleItemClick(index)"
        >
          <div class="inner-text">
            <h3 class="feature-title">{{ t(`home.features.list.item${index + 1}.title`) }}</h3>
            <div class="image-wrapper" v-if="!isPC">
              <img :src="item.image" :alt="t(`home.features.list.item${index + 1}.alt`)" />
            </div>
            <p
              class="feature-desc"
              :class="{ 'mobile-expanded': mobileExpandedIndex === index }"
            >
              {{ t(`home.features.list.item${index + 1}.description`) }}
            </p>
            <!-- PC端：只有当前选中项显示按钮 -->
            <div
              v-if="isPC && activeIndex === index"
              class="learn-more"
              @click.stop="handleLearnMore"
            >
              <span>{{ t('home.features.learnMore') }}</span>
              <div class="arrow-icon">
                <svg
                  data-v-a41d480e=""
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  data-v-f316e37b=""
                >
                  <path
                    data-v-a41d480e=""
                    d="M13 8.66671L16.3333 12L13 15.3334"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-a41d480e=""
                    d="M16.3334 12L7.66675 12"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <!-- 移动端：每个项目都有按钮 -->
            <div
              v-if="!isPC"
              class="learn-more"
              @click.stop="toggleMobileDescription(index)"
            >
              <span>{{
                mobileExpandedIndex === index ? t('home.features.collapse') : t('home.features.learnMore')
              }}</span>
              <div class="arrow-icon">
                <svg
                  data-v-a41d480e=""
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  data-v-f316e37b=""
                >
                  <path
                    data-v-a41d480e=""
                    d="M13 8.66671L16.3333 12L13 15.3334"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    data-v-a41d480e=""
                    d="M16.3334 12L7.66675 12"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧展示区域（仅PC端显示） -->
      <div v-if="isPC" class="feature-content">
        <div class="content-wrapper">
          <div class="image-container">
            <img :src="currentImage" :alt="t(`home.features.list.item${activeIndex + 1}.alt`)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

import Image1 from "../../assets/image/home/d1.webp";
import Image2 from "../../assets/image/home/d2.webp";
import Image3 from "../../assets/image/home/d3.webp";
import Image4 from "../../assets/image/home/d4.webp";

// 定义功能列表数据 - 使用计算属性响应语言变化
const features = computed(() => [
  {
    title: t('home.features.list.item1.title'),
    description: t('home.features.list.item1.description'),
    alt: t('home.features.list.item1.alt'),
    image: Image1,
  },
  {
    title: t('home.features.list.item2.title'),
    description: t('home.features.list.item2.description'),
    alt: t('home.features.list.item2.alt'),
    image: Image2,
  },
  {
    title: t('home.features.list.item3.title'),
    description: t('home.features.list.item3.description'),
    alt: t('home.features.list.item3.alt'),
    image: Image3,
  },
  {
    title: t('home.features.list.item4.title'),
    description: t('home.features.list.item4.description'),
    alt: t('home.features.list.item4.alt'),
    image: Image4,
  },
]);

// 当前激活的索引
const activeIndex = ref(0);
// 移动端展开的索引
const mobileExpandedIndex = ref(-1);
// 是否为PC端
const isPC = ref(true);

// 当前显示的图片
const currentImage = computed(() => {
  return features.value[activeIndex.value].image;
});

// 处理点击事件
const handleItemClick = (index) => {
  activeIndex.value = index;
};

// PC端了解详细按钮点击事件
const handleLearnMore = () => {
    window.open('https://www.d2plab.com/home', '_blank');
};

// 移动端切换描述展开状态
const toggleMobileDescription = (index) => {
window.open('https://www.d2plab.com/home', '_blank');
  if (mobileExpandedIndex.value === index) {
    mobileExpandedIndex.value = -1;
  } else {
    mobileExpandedIndex.value = index;
  }
};

// 检查设备类型
const checkDeviceType = () => {
  isPC.value = window.innerWidth > 768;
};

// 监听窗口大小变化
onMounted(() => {
  checkDeviceType();
  window.addEventListener("resize", checkDeviceType);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkDeviceType);
});
</script>

<style scoped>
.feature-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1920px;
  margin: 6rem auto;
  padding-inline: 6rem;
  gap: 2rem;
}

.feature-title {
  display: flex;
  flex-direction: row;
  gap: 4rem;
  justify-content: space-between;
  font-size: 1.8rem;
  font-weight: 500;
  color: #000;
  margin: 0 0 0.5rem 0;
  line-height: 1.4;
}

.feature-title .h1 {
  display: flex;
  flex: 1;
  font-size: 2.6rem;
  color: #000;
}

.feature-title .right-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 57%;
}

.inner-text {
  width: 100%;
  padding: 0 1rem;
}

.feature-title h1 {
  font-size: 2.6rem;
  font-weight: normal;
}

.feature-title h3 {
  font-size: 1.8rem;
  color: #000;
  font-weight: normal;
  margin-bottom: 0.6rem;
}

.feature-title p {
  font-size: 1.3rem;
  font-weight: normal;
  color: #666;
}

.list-wrap {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  margin-top: 2rem;
  gap: 1rem;
}

/* 左侧功能列表 */
.feature-list {
  flex: 1;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.feature-item {
  padding: 1.25rem 0;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.3s ease;
}

.feature-item:last-child {
  border-bottom: none;
}

.feature-item.active {
  background-color: #ecf3ef;
  border-radius: 4px;
}

.feature-desc {
  font-size: 1.13rem;
  color: #666;
  line-height: 1.5;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 移动端展开状态 */
.feature-desc.mobile-expanded {
  -webkit-line-clamp: unset;
}

/* 图片容器 */
.image-wrapper {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-wrapper img {
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
  border-radius: 4px;
}

/* 了解详细按钮 */
.health-more {
  align-items: center;
  background: #000;
  border-radius: 2.4rem;
  color: #fffc;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  height: 2.6rem;
  justify-content: center;
  padding-inline: 1rem 1rem;
  transition: all 0.2s ease-in-out;
  width: fit-content;
  margin-top: 1.5rem;
}

.health-more:hover {
  background-color: #444;
}

/* 右侧展示区域（仅PC端显示） */
.feature-content {
  background-color: #f6faf8;
  border-radius: 8px;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 57%;
}

.content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
}

.image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.learn-more {
  align-items: center;
  background: #000;
  border-radius: 2.4rem;
  color: #fffc;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  height: 2.6rem;
  justify-content: center;
  padding-inline: 1rem 1rem;
  transition: all 0.2s ease-in-out;
  width: fit-content;
  margin-top: 1.5rem;
}
@media (max-width: 992px) {
  .feature-container {
    flex-direction: column;
  }

  .feature-list {
    width: 100%;
    max-width: none;
    margin-bottom: 1rem;
  }

  .feature-content {
    width: 100%;
    max-width: none;
  }
}

@media (max-width: 768px) {
  .feature-container {
    padding: 2rem;
    margin: 1rem auto;
    gap: 1rem;
  }

  .feature-list {
    background: transparent;
  }

  .feature-item {
    padding: 1rem 0;
    margin-bottom: 2rem;
    background-color: #f8f9fa;
    border-radius: 8px;
  }
  .top{
    flex-direction: column;
    text-align: left;
    gap: 2rem;
  }
 .feature-title .right-text{
    width: 100%;
  }

  .feature-title {
    font-size: 1.6rem;
  }

  .feature-desc {
    font-size: 1.4rem;
    -webkit-line-clamp: 1;
  }

  .feature-content {
    padding: 1rem;
  }
  

  .list-wrap {
    flex-direction: column;
  }

  .feature-list,
  .feature-content {
    width: 100%;
  }

  .feature-title .h1,
  .feature-title .right-text {
    font-size: 2rem;
  }
}
</style>